<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout column pl-4 style="width: 650px;">
    <v-flex>
      <v-text-field ref="siqsQueryString" v-model="queryString" :placeholder="labels['titleSearchbox']" hide-details
        @input="onQueryInput" @change="onQueryChange"
      >
      </v-text-field>
    </v-flex>
    <v-flex>
      <v-progress-linear class="ma-0 mb-2" :indeterminate="isLoading"></v-progress-linear>
    </v-flex>
    <v-flex>
      <v-layout row>
        <v-flex sm6>
          <v-card class="ma-1">
            <v-card-title>{{ 'LABEL_SIQS_SEARCHRESULT' | translate }}</v-card-title>
            <v-card-text>
              <v-list :style="{overflow: 'auto', height: listHeight}">
                <v-list-tile v-for="entry in searchResult" key="entry.id" @click="onSelectSearchItem(entry.id)">
                  <v-list-tile-content >
                    <v-list-tile-title v-html="entry.title"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex sm6>
          <v-card class="ma-1">
            <v-card-title>{{ 'LABEL_SIQS_CURRENTDATA' | translate }}</v-card-title>
            <v-card-text>
              <v-list :style="{overflow: 'auto', height: listHeight}">
                <v-list-tile v-for="entry in resultList" key="entry.id">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="entry.title"></v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-icon @click="deleteSelectboxItem( $event, entry.id )">delete</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: "SearchItemQuerySelector",
    props: [ 'refFilterId', 'currentData', 'searchArea', 'eventUpdateQuerySelection', 'containerHeight' ],
    watch: {
    },
    computed: {
      isLoading() {
        return this.requestState.state !== null;
      },
      cHeight() {
        return this.listHeight;
      },
    },
    data() {
      return {
        requestState: { state: null },
        queryString: '',
        searchResult: [],
        resultList: [],
        listHeight: 450,
        labels: {
          titleSearchbox: Vue.i18n.translate('LABEL_SIQS_SEARCHBOX'), // TBT
        },
      };
    },
    methods: {
      onQueryInput(event) {
        Vue.prototype.$api.debug("onInput", {event: event});
        this.loadDynamicEntries(event);
      },
      onQueryChange (event) {
        Vue.prototype.$api.debug("onChange", {event: event});
      },
      onSelectSearchItem (event) {
        Vue.prototype.$api.debug("onSelectSearchItem", {event: event});
        const index = this.searchResult.findIndex(function (item, index) { return item.id === event; });
        if (index > -1) {
          this.resultList.push(this.searchResult[index]);
        }
      },
      deleteSelectboxItem (event, itemId) {
        const index = this.resultList.findIndex(function (item, index) { return item.id === itemId; });
        if (index > -1) {
          this.resultList.splice(index, 1);
          this.$props.currentData.splice(index, 1);
          event.stopPropagation();
        }
      },
      onResize () {
        if (this.$props.containerHeight) {
          this.listHeight = (this.$props.containerHeight - 48 - 15) + 'px';
          return;
        }
        const view = Vue.prototype.$api.viewport();
        const footerHeight = 35;
        const headerHeight = 100;
        const titleHeightOfMask = 95;
        let h2 = view.height - footerHeight - headerHeight - titleHeightOfMask - 90;
        this.listHeight = h2 + 'px';
      },
      loadDynamicEntries(query) {
        const cmp = this;

        if (!query) {
          this.searchResult = [];
        }

        let requestData = Vue.prototype.$api.injectRequestData({});
        requestData['action'] = 'searchSelectItems';
        requestData['q'] = query;
        requestData['w'] = this.searchArea;
        Vue.prototype.$api.sendPostRequest('ajaxSearchItemManager.php', requestData, this.requestState, function (data) {
          Vue.prototype.$api.debug("result dynamicSearch: ", {query: query, data: data});
          cmp.searchResult = data;
          //cmp.onresize();
        });
      },
    },
    created() {
      Vue.prototype.$api.debug('SearchItemQuerySelector created');
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      Vue.prototype.$api.debug('SearchItemQuerySelector destroyed');
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      const cmp = this;
      Vue.prototype.$api.debug('SearchItemQuerySelector mounted');
      if (this.currentData) {
        this.resultList = this.currentData;
      }
      this.onResize();
      this.$nextTick(function () { cmp.$refs.siqsQueryString.focus() } );
    }
  }
</script>

<style>
.v-list__tile {
  height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/components/module/mask/SearchItemQuerySelector.vue